import { IconButton } from '@mui/material';

import { GDMIconButtonComponent } from './GDMIconButton.type';

/* TODO: Implement component using GDM default design */
const GDMIconButton: GDMIconButtonComponent = props => <IconButton {...props} />;

export default GDMIconButton;
